import { OrganizationLevelType } from '../../../enums';
import { OrganizationLevel } from '../../../models/overmind/permissions';

export function extractOrganizationLevel(organizationLevels: OrganizationLevel[] | undefined, organizationLevelType: OrganizationLevelType): OrganizationLevel | undefined {
  if (!organizationLevels) return undefined;

  return organizationLevels.find(tempOrganizationLevel => tempOrganizationLevel.organizationLevel === organizationLevelType);
}
